export const adjustmentLabels = {
  completed: "Adjusted", failed: "Failed", pending: "In progress",
  partial: "Partially adjusted", none: "No adjustment recorded", unavailable: "History unavailable",
};
export const adjustmentColors = {
  completed: "bg-green-100 text-green-800", failed: "bg-red-100 text-red-800",
  pending: "bg-amber-100 text-amber-800", partial: "bg-amber-100 text-amber-800",
  none: "bg-gray-100 text-gray-700", unavailable: "bg-gray-100 text-gray-700",
};
export function adjustmentStatus(records) {
  if (!Array.isArray(records)) return "unavailable";
  if (!records.length) return "none";
  if (records.some((item) => item.status === "failed")) return "failed";
  if (records.some((item) => item.status === "pending")) return "pending";
  if (records.every((item) => item.status === "completed")) return "completed";
  return "partial";
}
export function adjustmentsForSku(records, sku) {
  if (!Array.isArray(records)) return null;
  const key = String(sku ?? "").trim();
  return key ? records.filter((item) => String(item.sku).trim() === key) : [];
}
export function formatAdjustmentTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", second: "2-digit", timeZoneName: "short",
  });
}
export function latestAdjustmentTime(records) {
  return (records || []).filter((item) => item.status === "completed" && item.adjusted_at)
    .map((item) => item.adjusted_at).sort((a, b) => new Date(b) - new Date(a))[0];
}
export const formatAdjustmentQuantity = (value) => value === null || value === undefined
  ? "—" : Number(value).toLocaleString(undefined, { maximumFractionDigits: 4 });
